export function jqToggleOpen() {

    jQuery(function ($) {

        // $('.js-ToggleOpen-btn').on('click', function () {
        //     const $wrap   = $(this).closest('.js-ToggleOpen');
        //     const $btn    = $(this);
        //     const $body   = $wrap.find('.js-ToggleOpen-body');

        //     // 1. 一度 is-active を外して、自然な高さを計測
        //     $body.removeClass('is-active');
        //     $body.css('max-height', ''); // いったん max-height をクリア

        //     // 2. 表示状態で「自然な高さ」を取得
        //     const naturalHeight = $body[0].scrollHeight; // jQuery で直接取得可能

        //     // 3. is-active に切り替え、その高さを max-height に設定
        //     if (!$btn.hasClass('is-active')) {
        //         // OPEN → CLOSE（開く側）
        //         $body.addClass('is-active');
        //         $body.css('max-height', naturalHeight + 'px');
        //         $btn.addClass('is-active');
        //         $btn.text('CLOSE');
        //     } else {
        //         // CLOSE → OPEN（閉じる側）
        //         $body.removeClass('is-active');
        //         $body.css('max-height', ''); // いったんクリア
        //         $btn.removeClass('is-active');
        //         $btn.text('OPEN');
        //     }
        // });

        $('.js-ToggleOpen-btn').on('click', function () {
            const $btn   = $(this);
            const $wrap  = $btn.closest('.js-ToggleOpen');
            const $body  = $wrap.find('.js-ToggleOpen-body');

            // 1. 一旦 is-active を外し、max-height をクリアして自然高さを取得
            $body.removeClass('is-active');
            $body.css('max-height', '');

            const naturalHeight = $body[0].scrollHeight; // その要素の実際の高さ

            if ($btn.hasClass('is-active')) {
                // CLOSE → OPEN（閉じる）
                $body.removeClass('is-active');
                $body.css('max-height', ''); // 初期の max-height がメディアクエリで適用
                $btn.removeClass('is-active');
                $btn.text('VIEW ALL');
            } else {
                // OPEN → CLOSE（開く）
                $btn.addClass('is-active');
                $btn.text('CLOSE');

                $body.addClass('is-active');
                $body.css('max-height', naturalHeight + 'px'); // その要素の「完全な高さ」を指定
            }
        });

    });

}
